// extracted by mini-css-extract-plugin
export default {"page-root":"Page_page-root__tygAg","page-content":"Page_page-content__ap0ez"};